export default __webpack_public_path__ + "static/media/Pic7.a815b29f.jpg";